module.exports = __webpack_public_path__ + "static/media/pin_nickel.0c84a00b.png";